export const EXAMPLE_COPY =
  "Here you'll see which finance rates are attached against the job. The rates shown here and indicative and might differ from what is available on your account.";
